export const setScrollBarHorizontalPosition = (element: null | HTMLElement, widthOfElement: number, index: number): void => {
  if (!element) return

  const positionOfX = widthOfElement * index
  element.scrollTo(positionOfX, 0)
};
